import styled from 'styled-components';
import { colors, fontWeight } from 'seedling/constants';

const ListItemWithNub = styled.div`
  box-sizing: border-box;
  margin-bottom: 1.5em;
  padding-left: 1em;
  border-left: 3px solid
    ${props => (props.active ? colors.mediumGreenhouseGreen : 'transparent')};
  font-size: 14px;
  font-weight: ${props =>
    props.active ? fontWeight.heavy : fontWeight.normal};
  color: ${props => (props.active ? colors.darkestGrey : colors.darkGrey)};
  cursor: pointer;

  /* add an indicator that we are hovering, unless we are the active nub */
  ${props =>
    !props.active &&
    `&:hover {
      border-left: 3px solid gray;
    }`}
`;

export default ListItemWithNub;
